export default __webpack_public_path__ + "static/media/interbank.cbee552f.webp";